import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/buildings',
      name: 'buildings',
      component: () => import(/* webpackChunkName: "buildings" */ './views/buildings/Buildings.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Buildings',
            disabled: false,
            exact: true,
            to: '/buildings'
          }
        ]
      }
    },
    {
      path: '/buildings/create',
      name: 'buildings-create',
      component: () => import(/* webpackChunkName: "buildings-create" */ './views/buildings/Create.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Buildings',
            disabled: false,
            exact: true,
            to: '/buildings'
          },
          {
            text: 'Create',
            disabled: true,
            to: '/buildings/create'
          }
        ]
      }
    },
    {
      path: '/buildings/:id/edit',
      name: 'buildings-edit',
      component: () => import(/* webpackChunkName: "buildings-edit" */ './views/buildings/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Buildings',
            disabled: false,
            exact: true,
            to: '/buildings'
          },
          {
            text: 'Edit',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/entrances',
      name: 'entrances',
      component: () => import(/* webpackChunkName: "entrances" */ './views/entrances/Entrances.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Entrances',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/entrances/create',
      name: 'entrances-create',
      component: () => import(/* webpackChunkName: "entrancesCreate" */ './views/entrances/Create.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Entrances',
            disabled: false,
            exact: true,
            to: '/entrances'
          },
          {
            text: 'Create',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/entrances/:id/edit',
      name: 'entrances-edit',
      component: () => import(/* webpackChunkName: "entrancesEdit" */ './views/entrances/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Entrances',
            disabled: false,
            exact: true,
            to: '/entrances'
          },
          {
            text: 'Edit',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/floors',
      name: 'floors',
      component: () => import(/* webpackChunkName: "floors" */ './views/floors/Floors.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Floors',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/floors/create',
      name: 'floors-create',
      component: () => import(/* webpackChunkName: "floorsCreate" */ './views/floors/Create.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Floors',
            disabled: false,
            exact: true,
            to: '/floors'
          },
          {
            text: 'Create',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/floors/:id/edit',
      name: 'floors-edit',
      component: () => import(/* webpackChunkName: "floorsEdit" */ './views/floors/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Floors',
            disabled: false,
            exact: true,
            to: '/floors'
          },
          {
            text: 'Edit',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/apartments',
      name: 'apartments',
      component: () => import(/* webpackChunkName: "apartments" */ './views/apartments/Apartments.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Apartments',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/apartments/create',
      name: 'apartments-create',
      component: () => import(/* webpackChunkName: "apartmentsCreate" */ './views/apartments/Create.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Apartments',
            disabled: false,
            exact: true,
            to: '/apartments'
          },
          {
            text: 'Create',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/apartments/:id/edit',
      name: 'apartments-edit',
      component: () => import(/* webpackChunkName: "apartmentsEdit" */ './views/apartments/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Apartments',
            disabled: false,
            exact: true,
            to: '/apartments'
          },
          {
            text: 'Edit',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/parkings',
      name: 'parkings',
      component: () => import(/* webpackChunkName: "parkings" */ './views/parkings/Parkings.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Parkings',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/parkings/create',
      name: 'parkings-create',
      component: () => import(/* webpackChunkName: "parkingsCreate" */ './views/parkings/Create.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Parkings',
            disabled: false,
            exact: true,
            to: '/parkings'
          },
          {
            text: 'Create',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/parkings/:id/edit',
      name: 'parkings-edit',
      component: () => import(/* webpackChunkName: "parkingsEdit" */ './views/parkings/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Parkings',
            disabled: false,
            exact: true,
            to: '/parkings'
          },
          {
            text: 'Edit',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/languages',
      name: 'languages',
      component: () => import(/* webpackChunkName: "languages" */ './views/languages/Languages.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Languages',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/languages/create',
      name: 'languages/create',
      component: () => import(/* webpackChunkName: "languagesCreate" */ './views/languages/Create.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Languages',
            disabled: false,
            exact: true,
            to: '/languages'
          },
          {
            text: 'Create',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/translations',
      name: 'translations',
      component: () => import(/* webpackChunkName: "translations" */ './views/translations/Translations.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Translations',
            disabled: true
          }
        ]
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      meta: {
        guest: true
      }
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: () => import(/* webpackChunkName: "gallery" */ './views/Gallery.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          {
            text: 'Dashboard',
            disabled: false,
            exact: true,
            to: '/'
          },
          {
            text: 'Gallery',
            disabled: true
          }
        ]
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (sessionStorage.getItem('accessToken') == null) {
      next({ path: '/login' })
    } else {
      store.commit('SET_LAYOUT', 'core-layout')
      next()
    }
  } else if(to.matched.some(record => record.meta.guest)) {
    if(sessionStorage.getItem('accessToken') == null) {
      next()
    } else {
      next('/')
    }
  } else {
    next() 
  }
})

export default router;